import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import department from "./slices/departmentSlice";
import officeType from "./slices/officeTypeSlice";
import officeSetup from "./slices/officeSetupSlice";
import designation from "./slices/designationSlice";
import design from "./slices/designSlice";
import category from "./slices/categorySlice";
import version from "./slices/versionSlice";
import product from "./slices/productSlice";
import productCode from "./slices/productCodeSlice";
import customerTeamRole from "./slices/customerTeamRoleSlice";
import customerType from "./slices/customerTypeSlice";
import leadType from "./slices/leadTypeSlice";
import orderProbability from "./slices/orderProbability";
import role from "./slices/roleSlice";
import sales from "./slices/salesSlice";
import salesStage from "./slices/salesStageSlice";
import discount from "./slices/discountSlice";
import Kpi from "./slices/KpiSlices";
import accountCreation from "./slices/accountCreationSlice";
import expense from "./slices/expenseSlice";
import stock from "./slices/stockSlice";
import stage from "./slices/stageSlice";
import area from "./slices/areaSlice";
import Leave from "./slices/leaveSlice";
import EarningStatement from "./slices/earningstatementSlice";
import Holiday from "./slices/holidaySlice";
import Employee from "./slices/employeelistSlice";
import Attendence from "./slices/attendenceSlice";
import Shift from "./slices/shiftSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    department,
    Attendence,
    officeType,
    officeSetup,
    designation,
    shift: Shift,
    design,
    category,
    expense,
    version,
    stage,
    area,
    product,
    productCode,
    customerTeamRole,
    customerType,
    leadType,
    Leave,
    EarningStatement,
    Holiday,
    orderProbability,
    role,
    stock,
    sales,
    salesStage,
    discount,
    Kpi,
    accountCreation,
    Employee,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
